import React from "react";
import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";

const MobileMenu = ({ navLinks, isActive, mobileOpen, mobileExpanded, setMobileExpanded }) => (
  <div
    className={`lg:hidden transition-all duration-300 ${
      mobileOpen ? "opacity-100" : "max-h-0 opacity-0 overflow-hidden"
    }`}
  >
    <div
      className="px-6 py-4 border-t border-gray-100 overflow-y-auto"
      style={{ maxHeight: "calc(100vh - 64px)" }}
    >
      {navLinks.map((link) => (
        <div key={link.name}>
          {/* Top-level link row */}
          <div className="flex items-center justify-between border-b border-gray-50">
            <Link
              to={link.path}
              className={`flex-1 py-3 text-base font-medium transition-colors ${
                isActive(link.path) ? "text-[#1B2A4A]" : "text-gray-600 hover:text-[#1B2A4A]"
              }`}
            >
              {link.name}
            </Link>
            {(link.children || link.groups) && (
              <button
                onClick={() =>
                  setMobileExpanded(mobileExpanded === link.name ? null : link.name)
                }
                className="p-2 text-gray-400 hover:text-[#1B2A4A]"
              >
                <ChevronDown
                  size={16}
                  className={`transition-transform duration-300 ${
                    mobileExpanded === link.name ? "rotate-180" : ""
                  }`}
                />
              </button>
            )}
          </div>

          {/* Simple children */}
          {link.children &&
            mobileExpanded === link.name &&
            link.children.map((child) => (
              <Link
                key={child.name}
                to={child.path}
                className="block py-2 pl-6 text-sm text-gray-500 hover:text-[#1B2A4A] transition-colors"
              >
                {child.name}
              </Link>
            ))}

          {/* Grouped mega-menu items */}
          {link.groups &&
            mobileExpanded === link.name &&
            link.groups.map((group) => (
              <div key={group.title} className="pl-4 pt-2 pb-1">
                <div className="text-[10px] font-bold text-[#C9A96E] uppercase tracking-widest mb-1">
                  {group.title}
                </div>
                {group.items.map((item) => (
                  <Link
                    key={item.name}
                    to={item.path}
                    className="block py-1.5 pl-3 text-sm text-gray-500 hover:text-[#1B2A4A] transition-colors"
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
            ))}
        </div>
      ))}
      <Link
        to="/booking"
        className="mt-4 block text-center py-3 bg-[#1B2A4A] text-white font-medium rounded-md hover:bg-[#2a3d62] transition-colors"
      >
        Book a Tee Time
      </Link>
    </div>
  </div>
);

export { MobileMenu };
